const getInitialState = (props) => {
  const {
    isAssign,
    assignment,
    isAssessmentForm,
    sectionsMinTimezone: defaultSectionsMinTimezone,
    isPreApSubject,
    disablePpcAutoAssignFlag,
    isPPC,
  } = props;
  const hasPreassignedBehavior = isAssessmentForm
    ? isPPC && !isPreApSubject && !disablePpcAutoAssignFlag
    : false;

  const submitBtnText = isAssign
    ? isAssessmentForm
      ? hasPreassignedBehavior
        ? 'Update'
        : 'Assign'
      : 'Assign'
    : 'Update';
  const sectionsMinTimezone =
    isAssessmentForm && assignment
      ? assignment.timezone
      : defaultSectionsMinTimezone;

  return {
    defaultTimezone: sectionsMinTimezone,
    sectionsMinTimezone,
    regularSections: [],
    updateSections: [],
    progressSections: [],
    canSubmit: false,
    submitBtnText,
    hasPreassignedBehavior,
    isPPC,
  };
};

export default getInitialState;
